// src/utils/muralExpiry.js
// Helpers para o prazo (expiresAt) das ofertas/demandas do mural.
import { Timestamp } from 'firebase/firestore';

// Formata um Date como 'YYYY-MM-DD' (no fuso local) para inputs type="date".
export const toDateInput = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

// 'YYYY-MM-DD' para hoje + N dias (default usado ao publicar).
export const dateInputOffset = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return toDateInput(d);
};

// Hoje como 'YYYY-MM-DD', usado como `min` do input de data.
export const todayInput = () => toDateInput(new Date());

// Converte 'YYYY-MM-DD' em Timestamp no fim daquele dia (23:59:59 local).
export const dateInputToTimestamp = (dateStr) => {
  if (!dateStr) return null;
  const [y, m, d] = dateStr.split('-').map(Number);
  return Timestamp.fromDate(new Date(y, m - 1, d, 23, 59, 59, 999));
};

// Converte Timestamp (ou {seconds}) em 'YYYY-MM-DD' para preencher o input.
export const timestampToDateInput = (ts) => {
  if (!ts) return '';
  const ms = ts.toMillis ? ts.toMillis() : ts.seconds * 1000;
  return toDateInput(new Date(ms));
};

// Milissegundos do prazo, ou null quando indefinido.
export const expiresAtToMillis = (ts) => {
  if (!ts) return null;
  return ts.toMillis ? ts.toMillis() : ts.seconds * 1000;
};

// Item vencido = tem prazo e ele já passou. Indefinido (sem expiresAt) nunca vence.
export const isExpired = (item) => {
  const ms = expiresAtToMillis(item.expiresAt);
  return ms != null && ms < Date.now();
};

// Rótulo legível do prazo (ex.: "31/12/2026" ou "Indefinido").
export const formatExpiry = (ts) => {
  const ms = expiresAtToMillis(ts);
  if (ms == null) return 'Indefinido';
  return new Date(ms).toLocaleDateString('pt-BR');
};
